export default function removeEmpty<T>(input: T, removeNull: boolean = false): Partial<T> {
  if (!input) {
    return {};
  }

  const newObj = {} as Partial<T>;

  Object.keys(input as object).forEach((key) => {
    const isUndefined = (input as Record<string, unknown>)[key] === undefined;
    const isNull = (input as Record<string, unknown>)[key] === null;
    const includeKey = removeNull ? !isNull && !isUndefined : !isUndefined;

    if (includeKey) {
      (newObj as Record<string, unknown>)[key] = (input as Record<string, unknown>)[key];
    }
  });

  return newObj;
}
